import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var WarningFilledIcon = function WarningFilledIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "WarningFilledIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m14.7 11.068-4.38-8.623a2.586 2.586 0 0 0-4.64 0L1.3 11.068C.391 12.858 1.655 15 3.62 15h8.76c1.965 0 3.229-2.142 2.32-3.932M8.915 5.5A.92.92 0 0 0 8 4.58a.92.92 0 0 0-.915.92V8a.915.915 0 1 0 1.83 0zM8 12.308a1.077 1.077 0 1 0 0-2.154 1.077 1.077 0 0 0 0 2.154",
      clipRule: "evenodd"
    })
  }));
};

export { WarningFilledIcon };
